import { render, staticRenderFns } from "./LoginPop.vue?vue&type=template&id=6f564b49&scoped=true"
import script from "./LoginPop.vue?vue&type=script&lang=js"
export * from "./LoginPop.vue?vue&type=script&lang=js"
import style0 from "./LoginPop.vue?vue&type=style&index=0&id=6f564b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f564b49",
  null
  
)

export default component.exports